import styled from "@emotion/styled";
import { theme } from "@styles/theme";
const { md, lg, xl } = theme.breakpoints;
//Types
import { IStepProps } from "./interface";
export const Container = styled.div`
  position: relative;
  display: table-cell;
  text-align: center;
  padding: 0.3em;
  &:after {
    content: " ";
    position: absolute;
    left: 50%;
    top: 1.75em;
    width: 100%;
    height: 0.125em;
    background-color: #e3e8ec;
    z-index: 1;
  }
  &:last-child:after {
    display: none;
  }
`;
export const Indicator = styled.div`
  position: relative;
  display: block;
  z-index: 2;
`;
export const Info = styled.div`
  position: relative;
  display: inline-block;
  width: 2.5em;
  height: 2.5em;
  border: 2px solid ${(props: IStepProps) => props.active};
  border-radius: 50%;
  font-size: 1.25em;
  line-height: 2.5em;
  text-align: center;
  color: #fff;
  z-index: 2;
  background: white;
`;
export const Content = styled.div`
  background: ${(props: IStepProps) => props.active};
  width: 92%;
  height: 92%;
  border-radius: 50%;
  margin: 2px auto;
`;
export const TitleStepper = styled.h4`
  color: #707070;
  font-family: "Poppins Regular";
  text-align: center;
  margin-top: 0.6em;
  font-weight: 400;
  font-size: 1em;
  margin-bottom: 0;
`;
